import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./RecuperarSenha.css";

const RecuperarSenha = () => {
  const [email, setEmail] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
  event.preventDefault();
  setMensagem("");
  setErro("");
  setLoading(true);

  try {
    const response = await fetch("https://welaunchyou.com.br/crm-wly/recuperar_senha.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    const raw = await response.text(); // lê como texto SEMPRE
    let data;
    try {
      data = raw ? JSON.parse(raw) : null;
    } catch {
      data = null;
    }

    if (!response.ok) {
      const msg = (data && data.error) || raw || `HTTP ${response.status}`;
      throw new Error(msg);
    }

    setMensagem((data && (data.message || data.msg)) || "E-mail de recuperação enviado com sucesso!");
  } catch (err) {
    setErro("Erro: " + (err.message || "Falha ao enviar solicitação."));
  } finally {
    setLoading(false);
  }
};

  

  return (
    <div className="login-container">
      <div className="login-form">
        <div className="login-header">
          <img
            src="https://welaunchyou.com.br/crm-wly/uploads/logos/logo-norea-n-branco2.png"
            alt="Logo Norea"
            className="login-logo"
          />
          <h2 style={{ borderBottom: "none" }}>Recuperar Senha</h2>
        </div>
        {mensagem && <p className="sucesso">{mensagem}</p>}
        {erro && <p className="erro">{erro}</p>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Digite seu e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Enviando..." : "Enviar"}
          </button>
        </form>

        <p className="forgot-password">
          <span onClick={() => navigate("/login")}>Voltar ao Login</span>
        </p>
      </div>
    </div>
  );
};

export default RecuperarSenha;
